// extracted by mini-css-extract-plugin
module.exports = {"comp":"content_comp__xIgCL"};